import { ContestViewContest } from '@freelancer/datastore';

export enum PreviewModalResponse {
  AWARD,
  BUY,
  START_CHAT,
}

export interface PreviewModalDetails {
  readonly contest: ContestViewContest;
  readonly imageSliderIndex: number;
  readonly isContestOwner: boolean;
  readonly hasContestAwardedEntry: boolean;
  readonly initialEntryId: number;
  readonly entryIds?: ReadonlyArray<number>;
  readonly isOnMultiAward: boolean;
  readonly canMultiAward: boolean;
}
